var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".r{fill:url(#j);}.s{fill:url(#m);}.t{fill:url(#i);}.u{fill:url(#q);}.v{fill:url(#p);}.w{fill:url(#n);}.x{fill:url(#l);}.y{fill:none;opacity:.9;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: -26.77767,
    cy: 94.69052,
    fx: -26.77767,
    fy: 94.69052,
    r: 139.91418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#acd1d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48508,
    stopColor: "#cfe6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99948,
    stopColor: "#f2fbff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 135.52709,
    cy: -40.76684,
    fx: 135.52709,
    fy: -40.76684,
    r: 129.42025,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 53.56116,
    cy: 15.06356,
    fx: 53.56116,
    fy: 15.06356,
    r: 216.98432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58132,
    stopColor: "#c1d4de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9fbfcf"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 60.57809,
    cy: 7.74154,
    fx: 60.57809,
    fy: 7.74154,
    r: 134.00002,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 45.69764,
    cy: -0.60405,
    fx: 45.69764,
    fy: -0.60405,
    r: 250.78584,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 109.08647,
    cy: -33.44482,
    fx: 109.08647,
    fy: -33.44482,
    r: 284.67225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a8cccf",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27639,
    stopColor: "#bcd9dc",
    stopOpacity: 0.57731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77372,
    stopColor: "#e0eff2",
    stopOpacity: 0.87995
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eff8fc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 91.59498,
    cy: -40.36006,
    fx: 91.59498,
    fy: -40.36006,
    r: 165.46901,
    xlinkHref: "#p"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("g", {
    id: "h",
    className: "y"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "t",
    points: "69.59177 61.30204 89.86552 73.00709 69.59177 84.71215 49.31627 73.00709 69.59177 61.30204"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "69.5909 61.30058 69.59264 37.88745 89.86814 49.59251 89.86726 73.00715 69.5909 61.30058"
  })), /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "x",
    points: "40.54598 21.14265 60.81973 32.8477 40.54598 44.55276 20.27048 32.8477 40.54598 21.14265"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "s",
    points: "40.54511 67.9674 40.54598 44.55276 60.81973 32.8477 60.81973 56.26083 40.54511 67.9674"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    points: "20.26874 56.26083 20.27048 32.8477 40.54598 44.55276 40.54511 67.9674 20.26874 56.26083"
  })), /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "30.4091 15.28785 50.68285 26.99291 30.4091 38.69796 10.13361 26.99291 30.4091 15.28785"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "u",
    points: "10.13186 50.40604 10.13361 26.99291 30.4091 38.69796 30.40823 62.1126 10.13186 50.40604"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMarkWhite);
export default __webpack_public_path__ + "static/media/logo-mark-white.28dc6e48.svg";
export { ForwardRef as ReactComponent };